<!-- MODAL HEADER-->
<div style="overflow: hidden;">
  <div class="row modal-bar">

    <div class="col-sm-6">
      <h5 class="modal-title">{{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.TITLE' | translate }}</h5>
    </div>

    <div class="col-sm-6">
      <div class="modal-actions">
        <div class="modal-close">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeDialog()"></button>
        </div>
      </div>
    </div>
  </div>

  <form class="form-content">
    <div class="section-wrapper">
      <div class="form-layout">
        <div class="row">
          <div class="col-lg-3">

            <div style="pointer-events: none;">
              @if (mostRecentItem.Status == TicketSwapStatusEnum.None) {
                <button class="btn btn-block blue bd-0">
                  <span>{{ "RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.STATUS.NONE" | translate }}</span>
                </button>
              }
              @if (mostRecentItem.Status == TicketSwapStatusEnum.Offered) {
                <button class="btn btn-block orange bd-0">
                  <span>{{ "RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.STATUS.OFFERED" | translate }}</span>
                </button>
              }
              @if (mostRecentItem.Status == TicketSwapStatusEnum.Accepted) {
                <button class="btn btn-block green bd-0">
                  <span>{{ "RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.STATUS.ACCEPTED" | translate }}</span>
                </button>
              }
              @if (mostRecentItem.Status == TicketSwapStatusEnum.Sold) {
                <button class="btn btn-block green bd-0">
                  <span>{{ "RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.STATUS.SOLD" | translate }}</span>
                </button>
              }
              @if (mostRecentItem.Status == TicketSwapStatusEnum.Withdrawn) {
                <button class="btn btn-block green bd-0">
                  <span>{{ "RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.STATUS.WITHDRAW" | translate }}</span>
                </button>
              }
              @if (mostRecentItem.Status == TicketSwapStatusEnum.Revoked) {
                <button class="btn btn-block red bd-0">
                  <span>{{ "RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.STATUS.REVOKED" | translate }}</span>
                </button>
              }
              @if (mostRecentItem.Status == TicketSwapStatusEnum.PendingInvitation) {
                <button class="btn btn-block orange bd-0">
                  <span>{{ "RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.STATUS.ASSIGNMENTINVITED" | translate }}</span>
                </button>
              }
              @if (mostRecentItem.Status == TicketSwapStatusEnum.InvitationDeclined) {
                <button class="btn btn-block red bd-0">
                  <span>{{ "RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.STATUS.DECLINED" | translate }}</span>
                </button>
              }
              @if (mostRecentItem.Status == TicketSwapStatusEnum.Assigned) {
                <button class="btn btn-block green bd-0">
                  <span>{{ "RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.STATUS.ASSIGNED" | translate }}</span>
                </button>
              }
              @if (mostRecentItem.Status == TicketSwapStatusEnum.AssignmentRequired) {
                <button class="btn btn-block orange bd-0">
                  <span>{{ "RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.STATUS.ASSIGNMENT-REQUIRED" | translate }}</span>
                </button>
              }
            </div>

            <br>

              <div class="row">
                <div class="col-lg-12">
                  <span>{{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.TICKETHOLDER' | translate }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <span [ngClass]="getIdentificationIconClass(true)" [title]="getIdentificationTooltip(true)"></span>
                  <span><b>
                    <t4-customer-identification-control [showCustomerNumber]="true" [customer]="constructCustomerIdentificationModel(true)"></t4-customer-identification-control>
                  </b></span>
                </div>
              </div>

              <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

              <div class="row">
                <div class="col-lg-12">
                  <span>{{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.BOUGHTBY' | translate }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <span [ngClass]="getIdentificationIconClass(false)" [title]="getIdentificationTooltip(false)"></span>
                  <span><b>
                    <t4-customer-identification-control [showCustomerNumber]="true" [customer]="constructCustomerIdentificationModel(false)"></t4-customer-identification-control>
                  </b></span>
                </div>
              </div>

              <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

              <div class="row">
                <div class="col-lg-12" style="text-transform: uppercase;">
                  <span>{{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.SECONDARYBOUGHTBY' | translate }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <span [ngClass]="getIdentificationIconClass(false)" [title]="getSecondaryIdentificationTooltip()"></span>
                  <span><b>
                    <t4-customer-identification-control [showCustomerNumber]="true" [customer]="constructSeondaryCustomerIdentificationModel()"></t4-customer-identification-control>
                  </b></span>
                </div>
              </div>

              <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

              <div class="row">
                <div class="col-lg-4">
                  <span>{{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.BARCODE' | translate }}</span>
                </div>
                <div class="col-lg-8">
                  <b>{{ mostRecentItem.Barcode | replaceOnEmpty }}</b>
                </div>
              </div>

              <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

              <div class="row">
                <div class="col-lg-4" style="text-transform: uppercase;">
                  <span>{{ 'RELATIONS.CUSTOMERCARD.PASSEPARTOUTS.LISTVIEW.HEADER.ORDER-NR' | translate }}</span>
                </div>
                <div class="col-lg-8">
                 <b><a href="#" (click)="openOrder($event, mostRecentItem.OrderId)">{{mostRecentItem.OrderId}}</a></b>
                </div>
              </div>

              <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

              <div class="row">
                <div class="col-lg-4">
                  <span>{{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.EVENT' | translate }}</span>
                </div>
                <div class="col-lg-8">
                  <b>{{ mostRecentItem.EventName | replaceOnEmpty }}</b>
                </div>
              </div>

              <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

              <div class="row">
                <div class="col-lg-4">
                  <span>{{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.DATETIME' | translate }}</span>
                </div>
                <div class="col-lg-8">
                  <b>{{ $any(mostRecentItem.EventStartDateTime) | localDate | replaceOnEmpty }} / {{ $any(mostRecentItem.EventStartDateTime) | localTime | replaceOnEmpty }}</b>
                </div>
              </div>

              <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

              <div class="row">
                <div class="col-lg-4">
                  <span>{{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.BLOCK' | translate }}</span>
                </div>
                <div class="col-lg-8">
                  <b>{{ mostRecentItem.SectionName | replaceOnEmpty }}</b>
                </div>
              </div>

              <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

              <div class="row">
                <div class="col-lg-4">
                  <span>{{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.ROWSEAT' | translate }}</span>
                </div>
                <div class="col-lg-8">
                  <b>{{ mostRecentItem.RowNumber | replaceOnEmpty }} / {{ mostRecentItem.SeatNumber | replaceOnEmpty }}</b>
                </div>
              </div>

              <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

            </div>
            <div class="col-lg-9">
              <app-ticket-scan-history class="mb-3" [eventPlacementId]="eventPlacementId"></app-ticket-scan-history>
              <div class="ticket-details-actions-row">
                <div class="table-header-container">
                  <span>{{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.HISTORY' | translate }}</span>
                </div>

                <div>
                  <button [hidden]="!isIbaActive" [disabled]="busy || !isIbaActive" (click)="openEditPolicy()" type="button" class="btn btn-small btn-primary border">
                    {{ 'RELATIONS.TICKET-ASSIGNMENT-HISTORY-DIALOG.EDIT-POLICY' | translate }}
                  </button>

                  <t4-dropdown-menu type="button" label="{{ 'HELPCENTER.BUTTON.DUPLICATE' | translate }}" style="height: -webkit-fill-available;">
                    <t4-dropdown-menu-item label="{{ 'HELPCENTER.BUTTON.PRINT' | translate }}" cssClass="fa-solid fa-print me-2" (action)="onPrintButtonClick()" [isDisabled]="!ticketPrintable() || busy"></t4-dropdown-menu-item>
                    <t4-dropdown-menu-item label="{{ 'HELPCENTER.BUTTON.DOWNLOAD' | translate }}" cssClass="fa-solid fa-download me-2" (action)="onDownloadButtonClick()" [isDisabled]="!ticketPrintable() || busy"></t4-dropdown-menu-item>
                    <t4-dropdown-menu-item label="{{ 'HELPCENTER.BUTTON.EMAIL' | translate }}" cssClass="fa-solid fa-envelope-open me-2" (action)="onEmailButtonClick()" [isDisabled]="!ticketPrintable() || busy"></t4-dropdown-menu-item>
                    <t4-dropdown-menu-item label="{{ 'HELPCENTER.BUTTON.REPLACE' | translate }}" cssClass="fa-solid fa-arrows-rotate me-2" (action)="onReplaceButtonClick()" [isDisabled]="busy || !canCreateDuplicate()"></t4-dropdown-menu-item>
                  </t4-dropdown-menu>

                  <button [disabled]="busy" (click)="openUpgrade()" type="button" class="btn btn-small btn-primary border">
                    {{ 'ADMINISTRATION.TICKETS.LISTVIEW.BUTTON.UPGRADE' | translate }}
                  </button>
                </div>

              </div>

              <t4-list-view #listVw [options]="listOptions" (onDataRequest)="OnDataRequest($event)">

                <ng-container *t4ListItem="let item">

                  <td>{{ item.Created | localDateTime | slice:0:10 }}</td>
                  <td>{{ item.Created | localTime }}</td>
                  <td>{{ (item.IsPrinted ? 'GENERIC.TICKETSWAPSTATUS.PRINTED' : getStatusValue(item.TicketSwapType, item.Status)) | translate }}</td>
                  <td>{{ item.ByCalculated }}</td>
                  <td>{{ item.ToCalculated }}</td>
                  <td>{{ item.Barcode | replaceOnEmpty }}</td>

                </ng-container>

              </t4-list-view>
            </div>
          </div>
        </div><!-- form-layout -->
      </div>
    </form>
  </div>